import React, { Component } from 'react';
import M from 'materialize-css/dist/js/materialize';
import { Input, ScannerCode } from '../../../../../../components/UI/ComponentsUI';
import { isNullOrEmpty, translate } from '../../../../../../utils/util'

class ConfirmModalDelivery extends Component {
    componentDidMount() {
        this.instance = M.Modal.init(this.modal);
    }

    onFinalize = () => {
        if (this.props.onConfirm) {
            const value = document.getElementById('qrCode').value;
            if (!isNullOrEmpty(value)) {
                this.props.onConfirm(value, () => {
                    this.close();
                });
            }
        }
    }

    scanner = (value) => {
        if (!isNullOrEmpty(value)) {
            const element = document.getElementById('qrCode');
            element.value = value;
        }
    };

    onCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
        this.close();
    };

    close() {
        if (this.props.onClose) {
            this.props.onClose();
        }
        M.Modal.getInstance(this.modal).close();
    }

    show() {
        this.instance.open();
        this.focus();
    }

    focus() {
        document.getElementById('qrCode').focus();
    }

    render() {
        return (
            <div>
                <div id={this.props.id ? this.props.id : 'confirm-modal'} ref={(modalEl) => this.modal = modalEl} className="modal" style={{ backgroundColor: '#ffffff' }}>
                    <div className="modal-content black-text">
                        <h4>{this.props.data.title}</h4>
                    </div>
                    <div className="row" style={{ marginBottom: '0px', paddingLeft: '20px' }}>
                        <div className="modal-content black-text">
                            {this.props.leave ? translate('delivery:message.informQrCode') : this.props.data.message}
                        </div>
                        <div className="input-field no-padding col s11">
                            <ScannerCode onScanner={this.scanner} />
                            <Input
                                id='qrCode'
                                name='qrCode'
                                type="text"
                                required={true}
                                label={translate('delivery:fields.qrCode')}
                                defaultValue=""
                            />
                        </div>
                    </div>
                    <div className="modal-footer" style={{ backgroundColor: '#ffffff' }}>
                        <div className="row">
                            <button
                                type="button"
                                onClick={this.onCancel}
                                className="col s6 m3 push-m6
                                    btn
                                    btn-flat
                                    waves-effect
                                    waves-light"
                            >
                                {translate('delivery:general.cancel')}
                            </button>
                            <button
                                type="button"
                                className={`col s6 m3 push-m6 btn btn-principal waves-effect waves-light`}
                                onClick={this.onFinalize}
                            >
                                {translate('delivery:general.confirm')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConfirmModalDelivery;
